.infoBox {
  width: 100%;
  background-color: var(--silver);
  padding: 2em;
  margin-bottom: 2em;
}

.label {
  flex-basis: 25%;
  text-align: right;
  padding-right: 2em;
}

.info {
  flex-basis: 75%;
}

.row {
  display: flex;
  min-height: 2em;

  p {
    margin-bottom: 0;
  }
}

.statusIcon {
  padding-right: 0.5em;
}
